
<template>
  <div id="app" class="app py-0" v-show='dataStore.loadedSuccessfully'>
    <v-app>
      <Toolbar/>
      <!--xs & sm-->
      <Searchbar class="d-flex d-sm-none d-none d-sm-flex d-md-none" />
      <v-main class="pa-0 ma-0">
        <Navbar
          :navbarHeight="getHeight"
          :class="[navbarOnImage ? 'navbaronimage' : 'navbar', 'd-none d-md-flex']"
        />
        <span v-if="authIntranet.isIntranet()">
          <ClientOnly>
            <slot />
          </ClientOnly>
        </span>

        <span v-else>
            <slot />
        </span>
      </v-main>
      <FooterBar />
      <cookiePopup  v-if="!runtimeConfig.public.IS_INTRANET"/>
    </v-app>
  </div>
</template>

<script setup> // to-do: add typeScript typeSafety with lang="ts"
import { onMounted, watch } from "vue";
import Toolbar from "@/components/App/toolBar.vue";
import Searchbar from "@/components/App/searchBar.vue";
import FooterBar from "@/components/Footer/footerBar.vue";
import cookiePopup from "@/components/Base/cookiePopup.vue";
import AOS from "aos";
import "aos/dist/aos.css";
import { useDataAll } from '@/store/dataAll';
import { useShoppingCartStore } from '@/layers/checkout/store/shoppingCart';
import { useSiteSettingsStore } from "../store/siteSettings";
import Navbar from "@/components/App/navBar.vue";

const navbarOnImage = useState('navbarOnImage', () => false);
const { isIntranet, goToLoginPageFrontendIntranet,setReturnUrl } = useIntranetAuth()
const dataStore = useDataAll();
const shoppingCartStore = useShoppingCartStore();
const { $apiMethods, $methods, $helpers } = useNuxtApp();
const authIntranet = useAuthIntranetStore();
const runtimeConfig = useRuntimeConfig();
const isMounted = ref(false);
const siteSettingsStore = useSiteSettingsStore();

// AOS hides [data-aos] elements with opacity:0 until its JavaScript adds the
// .aos-animate class (via AOS.init() on mount). Without JS that class is never
// added, so AOS-animated content (notably the entire IndexPage, the only view
// using data-aos on its content) stays invisible. This <noscript> override
// forces those elements fully visible when JavaScript is disabled, while
// leaving the animations intact when JS is enabled.
useHead({
  noscript: [
    {
      innerHTML: '<style>[data-aos]{opacity:1 !important;transform:none !important;}</style>',
      tagPriority: 'critical',
    },
  ],
});

// AOS hides [data-aos] elements with opacity:0 until its JavaScript adds the
// .aos-animate class (via AOS.init() on mount). Without JS that class is never
// added, so AOS-animated content (notably the entire IndexPage, the only view
// using data-aos on its content) stays invisible. This <noscript> override
// forces those elements fully visible when JavaScript is disabled, while
// leaving the animations intact when JS is enabled.
useHead({
  noscript: [
    {
      innerHTML: '<style>[data-aos]{opacity:1 !important;transform:none !important;}</style>',
      tagPriority: 'critical',
    },
  ],
});

// Fetch the data from the server - removed async from script setup
// const { pending } = await useAsyncData('mainData', async () => {
//   await dataStore.fetchDataIfNeeded();
//   // const siteJson = dataStore.getKey("siteJson", {});
//   // if (Object.keys(siteJson).length > 0) {
//   //   siteSettingsStore.populate(siteJson);
//   // }
//   return true;
// }, {
//   server: true,
//   lazy: false,
//   immediate: true,
//   dedupe: "defer"
// });

const { status } = await useAsyncData('checkoutData', async () => {
  const { useCheckoutInitialization } = await import('@/layers/checkout/composables/useCheckoutInitialization');
  const { initializeCheckout } = useCheckoutInitialization();

  // TODO: Check if we need to move this to middleware or leave here.
  // This will only once fetch the data in a user session (unless they reload a page)
  // Check how often we want to refetch the data
  // Once, eery page change, every minute (with timestamp in store), , only on cart/checkout changes, etc.

  await initializeCheckout();
  return true;
}, {
  server: false,
  lazy: false,
  immediate: true,
  dedupe: "defer"
});

// Watch for successful load and THEN change theme fields
watch(
  () => dataStore.loadedSuccessfully,
  (loaded) => {
    if (loaded) {
      // Apply theme changes when data is successfully loaded
      $methods.changeThemeFields(siteSettingsStore.getThemeFields);
    } else {
      if (isIntranet() && dataStore.getErrorStatusCode() == 401){
        const route = useRoute();  
        setReturnUrl(route.path)

        navigateTo(goToLoginPageFrontendIntranet()); 
      } else {
        console.error("Load error:", dataStore.getDataVar("errorStringLoad"));
      }
    }
  },
  { immediate: true }
);

onMounted(() => {
  // isMounted.value = true;
  AOS.init({});
});

const getHeight = computed(() => {
  const name = useNuxtApp().$vuetify?.display?.name.value;
  return name === 'xl' || name === 'xxl' ? 90 : 70;
});
</script>